export class CartConstants {
  public static readonly CART_BADGE_MAX_QUANTITY = 999;
  public static readonly CART_OVER_MAX_QUANTITY_LABEL = "999+";
}